import { computed, makeAutoObservable } from 'mobx'
import { getUserInfo } from '../services/ApiService'
import webSocketService from '../services/WebSocketService'
import { setGState } from '../utils/controllers/GlobalStateController'
import { userInfoStore } from '../views/RequestsManagement/RequestsSecondOperator/Table/stores/UserInfoStore'

class UserInfoStore {
  wsKey = 'UserInfoStore'

  constructor() {
    this.info = {}
    this.wsConnection = webSocketService
    makeAutoObservable(this, {
      canCreateOrder: computed,
    })
  }

  load = async (navigate) => {
    return getUserInfo()
      .then((res) => {
        this.info = res
        setGState('roles', res.roles)

        this.wsConnection.setSubscribe(this.wsKey, (data) => {
          if (data['permissions']) {
            this.info.permissions = data?.permissions
          }
        })

        userInfoStore.setUserInfo(res)
      })
      .catch((e) => navigate && navigate('/login'))
  }

  get userId() {
    return this.info.id ?? null
  }

  get userName() {
    return this.info.displayName ?? ''
  }

  get roles() {
    return this.info.roles || []
  }

  get permissions() {
    return this.info.permissions || {}
  }

  get canCreateOrder() {
    return this.info.permissions?.installationOrder?.canCreateOrder
  }

  get canCreateLoadedByOperatorOrder() {
    return this.info.permissions?.installationOrder
      ?.canCreateLoadedByOperatorOrder
  }
}

export default UserInfoStore
